import { render, staticRenderFns } from "./RouterViewWrapper.vue?vue&type=template&id=b33e6310&"
import script from "./RouterViewWrapper.vue?vue&type=script&lang=js&"
export * from "./RouterViewWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports